import {endpoints} from '@kapitalist/contract/endpoints'
import type {EmptyObject} from '@kapitalist/utils/EmptyObject'
import {PostApi} from '~/api/client'

const endpoint = endpoints.auth.logout

// response is a success code 204. Though we don't use that fact anywhere, yet
export default class SignOut extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(): EmptyObject {
    return {}
  }

  protected transformResponse(response: EmptyObject) {
    return response
  }

  protected successShouldResetSessionTimer() {
    return false
  }

  public mocksRequireLogin() {
    return true
  }
}
